import React, { useEffect, useState } from 'react';

const TestimonialsSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const companies = [
    '/images/companies/item-2.png',
    '/images/companies/item-3.png',
    '/images/companies/item-4.png',
    '/images/companies/item-6.png',
    '/images/companies/item-7.png',
    '/images/companies/item-8.png',
    '/images/companies/item-9.png',
    '/images/companies/item-10.png',
    '/images/companies/item-11.png',
    '/images/companies/item-12.png'
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % companies.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [companies.length]);

  const getVisibleCompanies = () => {
    const visible = [];
    for (let i = 0; i < 5; i++) {
      visible.push(companies[(currentIndex + i) % companies.length]);
    }
    return visible;
  };

  return (
    <section className="py-12 lg:py-16 bg-deepspace-100/30 backdrop-blur-xl">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Section Header */}
        <div className="text-center mb-12" data-aos="fade-up">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-text-primary mb-4">
            Trusted by Industry Leaders
          </h2>
          
          <p className="text-base sm:text-lg text-text-secondary max-w-3xl mx-auto">
            Join thousands of satisfied users who trust AureumVault to protect their digital assets with enterprise-grade security solutions.
          </p>
        </div>

        {/* Companies Slider */}
        <div className="relative overflow-hidden">
          <div className="flex items-center justify-center gap-6 lg:gap-8">
            {getVisibleCompanies().map((company, index) => (
              <div
                key={index}
                className="flex-shrink-0 transition-all duration-500"
                style={{
                  opacity: index === 2 ? 1 : 0.6,
                  transform: index === 2 ? 'scale(1.1)' : 'scale(1)'
                }}
              >
                <div className="bg-dark-card/50 backdrop-blur-sm border border-dark-border/50 rounded-xl p-4 sm:p-6 hover:border-cyber-blue/50 transition-all duration-300 hover:scale-105 w-32 h-20 sm:w-40 sm:h-24 lg:w-48 lg:h-28 flex items-center justify-center">
                  <img
                    src={company}
                    alt={`Company ${index + 1}`}
                    className="max-w-full max-h-full object-contain filter brightness-0 invert opacity-70 hover:opacity-100 transition-opacity duration-300"
                  />
                </div>
              </div>
            ))}
          </div>

          {/* Navigation Dots */}
          <div className="flex justify-center gap-2 mt-8">
            {companies.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`h-2 rounded-full transition-all duration-300 ${
                  index === currentIndex ? 'w-8 bg-cyber-blue' : 'w-2 bg-dark-border'
                }`}
              />
            ))}
          </div>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 mt-16">
          {[
            {
              name: 'Sarah Chen',
              role: 'DeFi Portfolio Manager',
              avatar: '/images/people/user-2-female.png',
              content: 'AureumVault has revolutionized how we manage our clients\' crypto assets. The AI-powered security features give us confidence that our portfolio is always protected.'
            },
            {
              name: 'Marcus Rodriguez',
              role: 'Blockchain Developer',
              avatar: '/images/people/user-1-man.png',
              content: 'The cold storage vault and transaction monitoring have been game-changers for my workflow. Best security solution I\'ve used.'
            },
            {
              name: 'Emily Watson',
              role: 'Crypto Investor',
              avatar: '/images/people/team-3-female.png',
              content: 'I sleep better knowing my assets are protected by military-grade encryption. The biometric authentication is fantastic.'
            }
          ].map((testimonial, index) => (
            <div
              key={index}
              className="bg-dark-card/80 backdrop-blur-sm border border-dark-border/50 rounded-2xl p-6 lg:p-8 hover:border-cyber-blue/50 transition-all duration-300 hover:scale-105 shadow-[0_8px_30px_rgb(0,0,0,0.5)]"
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              {/* Rating */}
              <div className="flex items-center mb-4">
                {[...Array(5)].map((_, i) => (
                  <svg key={i} className="w-4 h-4 text-cyber-gold" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                ))}
              </div>

              {/* Content */}
              <blockquote className="text-text-secondary leading-relaxed mb-6">
                "{testimonial.content}"
              </blockquote>

              {/* User Info */}
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-cyber-blue/30 transition-all duration-300 hover:border-cyber-blue">
                  <img
                    src={testimonial.avatar}
                    alt={testimonial.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <div className="font-semibold text-text-primary">{testimonial.name}</div>
                  <div className="text-sm text-text-muted">{testimonial.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;